import React from 'react';
import { Col, Row } from 'reactstrap';
import { Roles } from '../../constants/Roles';
import './index.css';

const ConfirmNote = ({ previewData }) => {
  let filterTmRemarks =
    previewData.remarks &&
    (previewData.remarks !== null || previewData.remarks !== 'undefined')
      ? previewData.remarks
          .filter((val) => val.role === Roles.TM_NAME)
          .filter(
            (unique, index) =>
              index ===
              previewData.remarks
                .filter((val) => val.role === Roles.TM_NAME)
                .findIndex(
                  (other) =>
                    unique.remark === other.remark &&
                    unique.action_by === other.action_by &&
                    unique.role === other.role
                )
          )
      : [];
  let filterShRemarks =
    previewData.remarks &&
    (previewData.remarks !== null || previewData.remarks !== 'undefined')
      ? previewData.remarks
          .filter((val) => val.role === Roles.SH_NAME)
          .filter(
            (unique, index) =>
              index ===
              previewData.remarks
                .filter((val) => val.role === Roles.SH_NAME)
                .findIndex(
                  (other) =>
                    unique.remark === other.remark &&
                    unique.action_by === other.action_by &&
                    unique.role === other.role
                )
          )
      : [];
  let filterNhRemarks =
    previewData.remarks &&
    (previewData.remarks !== null || previewData.remarks !== 'undefined')
      ? previewData.remarks
          .filter((val) => val.role === Roles.NH_NAME)
          .filter(
            (unique, index) =>
              index ===
              previewData.remarks
                .filter((val) => val.role === Roles.NH_NAME)
                .findIndex(
                  (other) =>
                    unique.remark === other.remark &&
                    unique.action_by === other.action_by &&
                    unique.role === other.role
                )
          )
      : [];
  return (
    <div id='confirmNote'>
      <Row>
        <Col xs={12}>
          <div className='d-flex align-items-center'>
            <div className='main-title'>Confirmation Note</div>
          </div>
        </Col>
        {
          <>
            <Col xs={12}>
              {filterTmRemarks.length > 0 &&
                filterTmRemarks.map((val, index) => {
                  return (
                    <div
                      className='subTitle d-flex flex-wrap align-items-center'
                      key={index}
                    >
                      <div>
                        <div>
                          {val.remark && <b>Confirmation Note from TM</b>}
                        </div>
                      </div>
                      <div className='value ml-2'>{val.remark}</div>
                    </div>
                  );
                })}
            </Col>
            <Col xs={12}>
              {filterShRemarks.length > 0 &&
                filterShRemarks.map((val, index) => {
                  return (
                    <div
                      className='subTitle d-flex flex-wrap align-items-center'
                      key={index}
                    >
                      <div>
                        <div>
                          {val.remark && <b>Confirmation Note from SH</b>}
                        </div>
                      </div>
                      <div className='value ml-2'>{val.remark}</div>
                    </div>
                  );
                })}
            </Col>
            <Col xs={12}>
              {filterNhRemarks.length > 0 &&
                filterNhRemarks.map((val, index) => {
                  return (
                    <div
                      className='subTitle d-flex flex-wrap align-items-center'
                      key={index}
                    >
                      <div>
                        {val.remark && <b>Confirmation Note from NH</b>}
                      </div>
                      <div className='value ml-2'>{val.remark}</div>
                    </div>
                  );
                })}
            </Col>
          </>
        }
      </Row>
    </div>
  );
};

export default React.memo(ConfirmNote);
